export enum HeaderHeight {
  mobile = 80,
  desktop = 112,
}

export enum Breakpoint {
  mobile = 1070,
}
